import {ProcedureGateway} from '../domain/procedure.gateway';

export class UpdateUseCase {
    constructor(private gate: ProcedureGateway) {}

    async execute(params: any): Promise<any> {
        return this.gate.updateProcedure(params);
    }
}
